import Model from "./Model";

export default class QuestionApplicationModel extends Model {
  id: number;
  questionId: number;
  examApplicationId: number;

  static __typename: string = "QuestionApplication";

  constructor(questionApplication: any, getters: any) {
    super(getters);
    this.id = questionApplication.id;
    this.questionId = questionApplication.questionId;
    this.examApplicationId = questionApplication.examApplicationByExamApplicationId || questionApplication.examApplicationId;
  }

  question() {
    return this.getters.questionById(this.questionId);
  }

  examApplication() {
    return this.getters.examApplicationById(this.examApplicationId);
  }
}